<nz-select
  [nzLoading]="loading"
  [ngModel]="selectedId"
  nzPlaceHolder="Selecteer profiel"
  i18n-nzPlaceHolder
  (ngModelChange)="onProfileChange($event)"
  nzSize="default"
  nzShowSearch
  [nzSuffixIcon]="userIcon"
>
  @for (profile of user?.profiles; track profile.id) {
    <nz-option [nzValue]="profile.id" [nzLabel]="profile.name"></nz-option>
  }
</nz-select>

<ng-template #userIcon>
  <i appIcon="image-user" faStyle="regular"></i>
</ng-template>
